import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AppService } from '../app.service';
import { HeaderData } from '../header/headerData';
import { environment } from '../../environments/environment';
import { Log } from 'ng2-logger';
import { OidcService } from '../auth/oidc.service';

const log = Log.create('Unauthorized');

@Component({
  selector: 'edit-unauthorized',
  styleUrls: ['unauthorized.less'],
  templateUrl: 'unauthorized.component.html',
})
export class UnauthorizedComponent implements OnInit, AfterViewInit {
  headerData: HeaderData = new HeaderData('Unauthorized');
  environment = environment;

  constructor(
    private appService: AppService,
    private oidcService: OidcService) {}

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.appService.headerData.title = 'Not logged in!';
    this.appService.headerData.path = [];
    this.oidcService.signoutRedirect();
  }
}



// WEBPACK FOOTER //
// ./src/app/unauthorized/unauthorized.component.ts